export default __webpack_public_path__ + "static/media/xamarin.fd90d9d1.svg";